module.exports = __webpack_public_path__ + "static/media/splash_bottom.bd763ffc.png";